import * as React from "react";
import { SubAccountType } from "../../../../../../Wrap/Constants/Enums/Domain/SubAccountType";
import { IProcessComponentProps, ProcessComponent } from "../../../../../Shared/Process/Process/ProcessComponent";
import { ClientAccountStore } from "../../../../Stroes/Variable";
import { SubAccountTypeHelper } from "../../Common/Helpers/SubAccountTypeHelper";
import { RegularPayment } from "../../Common/PaymentsIn/RegularPayment/RegularPayment";
import { SinglePayment } from "../../Common/PaymentsIn/SinglePayment/SinglePayment";
import { TransferIn } from "../../Common/PaymentsIn/TransferIn/TransferIn";
import { InvalidDpcTransferWarningText, InvalidNonDpcTransferWarningText, IsRestrictedToPensionContributionWarningText, PaymentType, processTypeEnum } from "../../Common/Resource/Contents";
import { Action } from "../../../../Actions/Action";
import { PensionContribution } from "../../../../../../Wrap/Models/Models/Processes/Apply/Pension/PensionContribution";
import { PensionAnnuityAssumption } from "../../Common/PaymentsIn/SIPP/PensionAnnuityAssumption";
import { ProcessType } from "../../../../../Shared/IST/Resource/Content";
import { PensionProtection } from "../../Common/PaymentsIn/SIPP/PensionProtection";
import { isRestrictedToPensionContribution } from "../../Common/PaymentsIn/SIPP/ValidationHelper";

interface IEditPaymentsInProps extends IProcessComponentProps {
    type: SubAccountType;
    subaccountHierarchyId: string; 
}

interface IEditPaymentsInState {
    hasDisqualifyingPensionCredit: boolean;
}

export class EditPaymentsIn extends ProcessComponent<IEditPaymentsInProps, IEditPaymentsInState> {
    constructor(props: IEditPaymentsInProps) {
        super(props);
        this.state = {
            hasDisqualifyingPensionCredit: false
        };
    }

    componentDidMount() {
        super.componentDidMount();
        Action.getPensionSubAccountSettings(this.props.subaccountHierarchyId, true, (val) => {
            this.setState(
                {
                    hasDisqualifyingPensionCredit: val?.HasDisqualifyingPensionCredit ?? false
                }
            );
        });
    }

    isValid() {
        const flag = super.isValid();
        
        var passDpcCheck = true;
        if (this.props.type == SubAccountType.Npr) {
            var contribution = this.props.data?.Contribution as PensionContribution;
            var hasAnyDpcTransfer = contribution?.PensionTransfers?.some((t) => t.PensionDetails?.IsDisqualifyingPensionCredits);
            passDpcCheck = this.state.hasDisqualifyingPensionCredit == hasAnyDpcTransfer;

            if (!passDpcCheck && this.state.hasDisqualifyingPensionCredit) {
                this.props.showErrorMsgPopUp([InvalidNonDpcTransferWarningText]);
            }
            else if (!passDpcCheck && !this.state.hasDisqualifyingPensionCredit) {
                this.props.showErrorMsgPopUp([InvalidDpcTransferWarningText]);
            }
        }

        let isRestrictedProtection = false;
        if (this.props.data?.Contribution?.HasPensionProtection && this.props.data?.Contribution?.PensionProtection) {
            isRestrictedProtection = isRestrictedToPensionContribution(
                this.props.data?.Contribution?.PensionProtection
            );
            if (isRestrictedProtection) {
                this.props.showErrorMsgPopUp([IsRestrictedToPensionContributionWarningText]);
            }
        }

        return flag && passDpcCheck && !isRestrictedProtection;
    }


    private getProps = (key) => {
        const { onChange, data, showErrorMsgPopUp, isReview } = this.props;
        return {
            data: data[key],
            onRef: (ref) => this.appendChild(ref),
            showErrorMsgPopUp: (msg, isShow) => showErrorMsgPopUp(msg, isShow),
            onChange: (changes) => this.onDataChange(onChange, changes, data, key),
            isReview: isReview,
        };
    };

    private getTransfersType = (type) => {
        if (SubAccountTypeHelper.isPP(type)) {
            return "GiaTransfers";
        } else if (SubAccountTypeHelper.isIsa(type)) {
            return "IsaTransfers";
        } else {
            return "PensionTransfers";
        }
    };

    private getPaymentTypes = (type) => {
        if (SubAccountTypeHelper.isOnPlatformPension(type)) {
            return [PaymentType.Client, 
                    PaymentType.ThirdParty, 
                    PaymentType.EmployerSalaryDeduction,
                    PaymentType.Employer]
        }
        else {
            return [PaymentType.Client, PaymentType.ThirdParty]
        }
    }

    public render(): JSX.Element {
        const { data, onChange, type } = this.props;
        return (
            <div>
                <h2>Payments in</h2>
                <PensionAnnuityAssumption {...this.getProps("Contribution")} processType={ProcessType.WhatIf} />
                <PensionProtection {...this.getProps("Contribution")} label={"Edit pension protection"} />
                <hr />
                <SinglePayment
                    {...this.getProps("Contribution")}
                    clientInfo={this.props.data.ClientDetails}
                    checkBoxOption={this.getPaymentTypes(type)}
                    subAccountType={type}
                    hasPaymentMethod={false}
                    processType={processTypeEnum.WhatIfTool}
                />
                <hr />
                <RegularPayment
                    {...this.getProps("Contribution")}
                    clientInfo={this.props.data.ClientDetails}
                    checkBoxOption={this.getPaymentTypes(type)}
                    subAccountType={type}
                    hasContinue={true}
                    hasIndexation={false}
                    processType={processTypeEnum.WhatIfTool}
                />
                <hr />
                <TransferIn
                    isPost={false}
                    data={
                        this.props.data.Contribution?.[
                            this.getTransfersType(type)
                        ]
                    }
                    subAccountType={type}
                    jouneryType={processTypeEnum.WhatIfTool}
                    onChange={(changes) =>
                        this.onDataChange(
                            (changes) => this.onDataChange(onChange, changes, data, "Contribution"),
                            changes,
                            data.Contribution
                        )
                    }
                    isReview={this.props.isReview}
                    showErrorMsgPopUp={this.props.showErrorMsgPopUp}
                    onRef={(ref) => this.appendChild(ref)}
                    hasCashIsa={ClientAccountStore.getClientAccountInfo().SubAccounts.some(
                        (ele) => ele.SubAccountType == SubAccountType.CashIsa
                    )}
                    accountServiceProposition={this.props.data.AccountServiceProposition}
                />
            </div>
        );
    }
}
